import { COLLAPSE_SIDEBAR } from "../../constants/action.constants";

const initialState = {
  collapseSidebar: true,
};

const collapseSidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case COLLAPSE_SIDEBAR:
      return { collapseSidebar: !state.collapseSidebar };
    default:
      return state;
  }
};

export default collapseSidebarReducer;
